import { useHandler } from "@suse-o11y/use-handler";
import { type Dispatch, createContext, useContext } from "react";

interface ScrollingContainerContextValue {
	element: null | HTMLElement;
}

const ScrollingContainerContext = createContext<null | ScrollingContainerContextValue>(null);

export const ScrollingContainerContextProvider = ScrollingContainerContext.Provider;

export interface UseScrollingContainerResult extends ScrollingContainerContextValue {
	scrollTo: Dispatch<ScrollToOptions>;
}

export const useClosestScrollingContainer = (): UseScrollingContainerResult => {
	const context = useContext(ScrollingContainerContext);
	const element = context?.element ?? document.body;

	const scrollTo = useHandler((options: ScrollToOptions) => {
		element?.scrollTo(options);
	});

	return { element, scrollTo };
};

export const useClosestScrollingContainerOrNull = (): null | UseScrollingContainerResult => {
	const context = useContext(ScrollingContainerContext);

	const scrollTo = useHandler((options: ScrollToOptions) => {
		context?.element?.scrollTo(options);
	});

	return context == null ? null : { element: context.element, scrollTo };
};
